
import { MetricsTabs } from "./metrics/MetricsTabs";

export const MetricsTab = () => {
  return <MetricsTabs />;
};
